import { useTranslation } from "react-i18next";
import { IconButton } from "@/components/ui/icon-button";
import IconContainer from "@/components/ui/icon-container";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from "@/components/ui/tooltip";
import { Loader } from "@dreamhub/designsystem/icons";
import { Regenerate as RegenerateIcon } from "@dreamhub/designsystem/icons";

interface Props {
  onRegenerate: () => void;
  isGenerating: boolean;
}

// Retry control in the card's top-right corner. It takes no input of its own —
// it regenerates from the same context. While a regeneration is in flight the
// icon is replaced by a spinner.
const DraftEmailRegenerate = ({ onRegenerate, isGenerating }: Props) => {
  const { t } = useTranslation();

  if (isGenerating) {
    return (
      <span
        className="flex size-6 items-center justify-center"
        data-test="draft-email-generating"
        role="status"
        aria-label={t("draftEmail.regenerating")}
      >
        <IconContainer size="sm" color="tertiary" className="animate-spin">
          <Loader />
        </IconContainer>
      </span>
    );
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <IconButton
          variant="icon"
          size="md"
          iconColor="primary"
          iconClassName="size-4"
          onClick={onRegenerate}
          data-test="draft-email-retry"
          aria-label={t("draftEmail.retry")}
        >
          <RegenerateIcon />
        </IconButton>
      </TooltipTrigger>
      <TooltipContent>{t("draftEmail.retry")}</TooltipContent>
    </Tooltip>
  );
};

export default DraftEmailRegenerate;
